import Footer from '../Components/Footer';
import Header from '../Components/Header';
import Wik from '../Components/WikiComp/Wik';

function WikPage() {

    return (
        <div>
            <Header/>
            <Wik/>
            <Footer/>
        </div>
    );
}

export default WikPage;